<div class="h-full relative">

  <div class="h-full flex justify-center items-center">

    <button (click)="toggleMenu()">
      <app-menu-btn [open]="isOpen"></app-menu-btn>
    </button>

  </div>

  <div class="absolute -left-4 top-full z-[4] transform transition-transform duration-300 ease-in-out"
    [class]="{'-translate-x-full': !isOpen}">
    <app-filters [filters]="filtersData" (closemenu)="closeMenu()"></app-filters>
  </div>

</div>